import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-flag-ie",
  "use": "icon-flag-ie-usage",
  "viewBox": "0 0 1532 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1532 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-flag-ie\"><defs><style type=\"text/css\"></style></defs><path d=\"M0 1024V0h1532.947v1024z m1529.741-3.12z m-1523.33-3.24h1520.124V6.258H6.411z\" fill=\"#231F20\" p-id=\"1337\" /><path d=\"M3.206 3.138h508.828v1017.69H3.206z\" fill=\"#009A63\" p-id=\"1338\" /><path d=\"M512.034 3.138h508.828v1017.69H512.034z\" fill=\"#FFFFFF\" p-id=\"1339\" /><path d=\"M1020.862 3.138h508.862v1017.69h-508.862z\" fill=\"#FF823D\" p-id=\"1340\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/flag-ie.svg
// module id = Fm5s
// module chunks = 24